import ApiClient from '@/api/settings/axios';

const apiClient = new ApiClient();

const requestSendSMS = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/send_sms',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

const requestCheckSMS = ({ csrfToken, postParams }) => {
  const result = apiClient.post(
    '/user/check_sms',
    { csrfToken, postParams },
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

export {
  requestSendSMS,
  requestCheckSMS,
};
